import styled from "styled-components";

import Button from "core/Button";

import { convertPxToRem } from "frontend/components/helpers";

export const CopyButton = styled(Button).attrs({
    size: "sm"
})`
    position: absolute;
    bottom: ${convertPxToRem({ px: 20 })};
    right: ${convertPxToRem({ px: 20 })};
`;
